<template>
  <div>
    <div style="text-align: right; margin-bottom: 12px">
      <el-popconfirm title="确定要清除已填写的内容吗？" @confirm="clean">
        <el-button
          slot="reference"
          icon="el-icon-refresh-left"
          type="info"
          round
          size="large"
          style="padding: 4px 12px"
        >
          清除
        </el-button>
      </el-popconfirm>
      <el-popconfirm title="确定要保存了吗？" @confirm="save">
        <el-button
          slot="reference"
          icon="el-icon-finished"
          type="success"
          round
          size="large"
          style="padding: 4px 12px"
        >
          保存
        </el-button>
      </el-popconfirm>
    </div>
    <editor ref="editor" />
  </div>
</template>

<script>
import Editor from './Editor.vue'
import { enterpriseAdd } from '@/api/enterprise.js'
export default {
  name: 'Add',
  components: { Editor },
  data() {
    return {}
  },
  mounted() {
    console.log("Add")
  },
  computed: {
    editor() {
      return this.$refs.editor
    },
    userId() {
      return this.$store.getters.userId
    }
  },
  methods: {
    clean() {
      this.$refs.editor.reset()
    },
    save() {
      // const data = this.$refs.editor.getInfo()
      let that=this
      this.$refs.editor.formSubmit(f,that)
      function f(that) {
        that.$emit('added')
      }
      this.$emit('rest')
      // this.$emit('added')
      // data.userId=this.userId
      // enterpriseAdd(data).then((resp) => {
      //   const ent = resp.data
      //
      // })
    },
    leave() {
      const { editor } = this
      editor.reset()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/meta/enterprise/Add.vue